"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const enums_1 = require("../enums");
const class_transformer_1 = require("class-transformer");
const GetNextBestInformationalResponseInformational_1 = tslib_1.__importDefault(require("./GetNextBestInformationalResponseInformational"));
class GetNextBestInformationalResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: 'a19d7a21-736f-4025-ae54-ba0eae77730a', description: 'Profile identifier' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalResponse.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({ example: base_models_1.Brand.ESSENT, description: 'Brand the informational is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalResponse.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Channel)),
    (0, base_models_1.Docs)({ example: enums_1.Channel.MIJN, description: 'Channel the informational is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalResponse.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetNextBestInformationalResponseInformational_1.default),
    tslib_1.__metadata("design:type", Array)
], GetNextBestInformationalResponse.prototype, "informationals", void 0);
exports.default = GetNextBestInformationalResponse;
